module.exports = __webpack_public_path__ + "static/media/egg_xiazai_zhuli.abc54480.png";